/**
 * Motivo de recusa visível no detalhe da venda.
 *
 * Pedidos antigos podem ter o nome da adquirente ou um slug técnico em last_message.
 * Esse texto não é reescrito no banco: aqui só se escolhe o que mostrar.
 * Código conhecido vira tradução. Frase já humana passa. O resto cai no fallback.
 */

const KNOWN_PROVIDER_NAMES = [
  'PayRetailers',
  'Pagar.me Bolsão',
  'Pagar.me',
  'PagBank Internacional',
  'PagBank Brasil',
  'Stripe Internacional',
  'Stripe Brasil',
  'Stripe Esfera',
  'Stripe',
  'Payments.AI',
  'FourOn',
  'WEpayments',
  'Únicopag',
  'Unicopag',
  'Coinflow',
  'PayPal',
  'PicPay',
  'SimPay',
  'Citcon',
  'Breeze',
  'PagBank',
  'VPago',
  'Juspay',
  'Appmax',
  'Marlim',
  'MaxanaPay',
  'Maxana',
  'Whop',
  '4on',
  'NMI',
] as const;

/** Slug de status ou sufixo técnico gravado pelo webhook antigo. */
const TECHNICAL_DECLINE =
  /\b(not_authorized|refused|failed)\b|transação\s+\S+|reason\s*:/i;

export type SaleDeclineFields = {
  last_message?: string | null;
  error_code?: string | null;
};

type Translate = (
  key: string,
  options?: { defaultValue?: string },
) => string;

export function declineReasonForDisplay(
  sale: SaleDeclineFields,
  t: Translate,
): string {
  const fromCode = translationForErrorCode(sale.error_code, t);

  if (fromCode) {
    return fromCode;
  }

  const lastMessage = (sale.last_message ?? '').trim();

  if (lastMessage && isPublicDeclineMessage(lastMessage)) {
    return lastMessage;
  }

  return t('decline_reason.not_authorized');
}

function translationForErrorCode(
  errorCode: string | null | undefined,
  t: Translate,
): string | null {
  const code = (errorCode ?? '').trim();

  if (!code) {
    return null;
  }

  const key = `error_codes.${code}`;
  const translated = t(key, { defaultValue: '' }).trim();

  if (!translated || translated === key || translated === code) {
    return null;
  }

  return translated;
}

function isPublicDeclineMessage(message: string): boolean {
  if (TECHNICAL_DECLINE.test(message)) {
    return false;
  }

  const normalized = message.toLowerCase();

  return !KNOWN_PROVIDER_NAMES.some((name) =>
    normalized.includes(name.toLowerCase()),
  );
}
